module.exports = __webpack_public_path__ + "assets/49b8719781ba6e1c649da22749c9afa9.png";